import type { ThunkReturnType } from "types";
import { createAsyncThunk } from "infrastructure/store/lib";
import type { AsyncThunk, RootState } from "infrastructure/store";
import { ApiState } from "infrastructure/api";
import { ApiRouteTypes } from "consts/enpoints/api";
import { payloadCreator } from "util/api";
import { concat } from "util/support";
import { getTransactionDetails, getTransactions } from "features/transactions/api";
import type { Transaction, TransactionResponse, TransactionsResponse } from "./types";
import { sliceToken } from "./state";

export const getTransactionsThunk: AsyncThunk<
    ThunkReturnType<TransactionsResponse>,
    string,
    {}
> = createAsyncThunk(
    concat([sliceToken, ApiRouteTypes.GetTransactions]),
    payloadCreator(getTransactions),
    {
        condition: (_, { getState }) => {
            const { transactions } = getState() as RootState;
            return ![ApiState.Pending].includes(transactions.tableLoadingState);
        }
    }
);

export const getTransactionDetailsThunk: AsyncThunk<
    ThunkReturnType<TransactionResponse>,
    Pick<Transaction, 'coreId' | 'MOR'>,
    {}
> = createAsyncThunk(
    concat([sliceToken, 'GetTransactionDetails']),
    payloadCreator(getTransactionDetails),
    {
        condition: (_, { getState }) => {
            const { transactions } = getState() as RootState;

            return ![ApiState.Pending].includes(transactions.transactionDetailsLoadingState);
        }
    }
);
